import {
    AccountCategory,
    type AccountSummary,
    type HolisticSummary,
    type HolisticSummaryCategory,
    SpendAccountCategory,
} from '@fruitful/types';
import {
    BarChartIcon,
    CreditCardIcon,
    DollarSignIcon,
    type IconType,
    LandmarkIcon,
    PiggyBankIcon,
} from 'smoothie';

export {
    AccountCategory,
    type AccountSummary,
    Provider,
    SpendAccountCategory,
} from '@fruitful/types';

export enum FruitfulAccountCategory {
    FRUITFUL = 'fruitful',
}

export type GroupedAccountId = string;
export interface GroupedAccount extends AccountSummary {
    groupedAccountId: GroupedAccountId;
}

export type AccountGroupCategory =
    | AccountCategory
    | SpendAccountCategory
    | FruitfulAccountCategory;

export interface AccountGroup {
    accountGroupCategory: AccountGroupCategory;
    heading: string;
    accounts: GroupedAccount[];
}

export type AccountGroups = Partial<Record<AccountGroupCategory, AccountGroup>>;

export const AccountCategoryIcons: Record<HolisticSummaryCategory, IconType> = {
    [AccountCategory.SPEND]: CreditCardIcon,
    [AccountCategory.SAVE]: PiggyBankIcon,
    [AccountCategory.INVEST]: BarChartIcon,
    [AccountCategory.BORROW]: LandmarkIcon,
};

export const SpendCategoryIcons: Record<SpendAccountCategory, IconType> = {
    [SpendAccountCategory.CASH]: DollarSignIcon,
    [SpendAccountCategory.CREDIT]: CreditCardIcon,
};

export interface Transaction {
    id: string;
    amount: number;
    date: string;
    description: string;
    rawDescription: string;
    accountId: string;
    type: string;
    status: string;
    pending: boolean;
}

export interface HolisticSummaryCache {
    holisticSummary?: HolisticSummary;
    dataUpdatedAt?: number;
    userId?: string;
}
